// La Despe · menú del móvil
document.addEventListener('click', function (e) {
  var boton = e.target.closest('[data-abrir-menu]');
  if (!boton) return;
  var cabecera = boton.closest('.cabecera');
  var abierta = cabecera.classList.toggle('abierta');
  boton.setAttribute('aria-expanded', abierta ? 'true' : 'false');
});

// Calculadora de «Precio de tu despe, al momento»
document.querySelectorAll('[data-calc]').forEach(function (calc) {
  var personas = parseInt(calc.querySelector('[data-personas]').textContent, 10) || 10;
  var packs = calc.querySelectorAll('[data-pack]');
  if (!calc.querySelector('[data-pack][aria-checked="true"]') && packs[0]) packs[0].setAttribute('aria-checked', 'true');
  var euros = function (n) { return n.toFixed(2).replace('.', ',').replace(',00', '') + ' €'; };
  function pinta() {
    var marcado = calc.querySelector('[data-pack][aria-checked="true"]');
    var precio = marcado ? parseFloat(marcado.dataset.precio) : 0;
    calc.querySelector('[data-personas]').textContent = personas;
    calc.querySelector('[data-por-persona]').textContent = euros(precio);
    // pagan todos menos el protagonista
    calc.querySelector('[data-total]').textContent = euros(precio * (personas - 1));
  }
  calc.querySelector('[data-menos]').addEventListener('click', function () { personas = Math.max(6, personas - 1); pinta(); });
  calc.querySelector('[data-mas]').addEventListener('click', function () { personas = Math.min(60, personas + 1); pinta(); });
  packs.forEach(function (b) {
    b.addEventListener('click', function () {
      packs.forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
      b.setAttribute('aria-checked', 'true');
      pinta();
    });
  });
  pinta();
});
